
export default {
  // Company Information
  companyInformation: "Client Information",
  brandInformation: "Brand Information",
  contactInformation: "Contact Information",
  companyName: "Company Name",
  brandName: "Brand Name",
  personInCharge: "Person in Charge",
  jobTitle: "Job Title",
  campaignEmail: "Email Address",
  mobileNumber: "Mobile Number",
  enterCompanyName: "Enter your company name",
  enterBrandName: "Enter your brand name",
  enterPersonName: "Enter the person's full name",
  enterJobTitle: "Enter the job title",
  enterEmail: "Enter your email address",
  enterMobile: "Enter your mobile number",
} as const;
